// Hook CDC para registrar mensagens i18n adicionais no app vue-i18n do dashboard.
// Chamado uma vez após `app.use(i18n)` em `app/javascript/entrypoints/dashboard.js`
// (única edição upstream desta infra — ver `custom/EXTENSIONS.md`). Faz deep-merge
// incremental por locale via `i18n.global.mergeLocaleMessage`, que é a API estável
// do Composer global no modo composition (`legacy: false`).
// Origem: ADR 0006.
//
// I18N-02 (CONTEXT D-04/D-05/D-06): em dev/test, asserta que o payload CDC só
// contém a chave top-level `CDC` e que o target i18n ainda não tem subtree `CDC`
// pré-existente. Em produção a checagem é no-op (zero overhead de bundle/runtime).
// Sem spec/script separado — esta assertion runtime é o único guardrail.

/* eslint-disable no-console */

import messages from './messages.js';

export function registerCdcLocale(i18n) {
  Object.entries(messages).forEach(([locale, payload]) => {
    if (import.meta.env.DEV || import.meta.env.MODE === 'test') {
      if (Object.keys(payload).length !== 1 || payload.CDC === undefined) {
        console.error(
          `I18N collision: CDC namespace contract violation for locale ${locale}`
        );
        throw new Error('I18N collision: CDC namespace contract violation');
      }
      if (i18n.global.messages.value[locale]?.CDC) {
        console.error(
          `I18N collision: CDC subtree already present in target for locale ${locale}`
        );
        throw new Error('I18N collision: CDC namespace conflict');
      }
    }
    i18n.global.mergeLocaleMessage(locale, payload);
  });
}
